














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LoaderComponent extends Vue {
    @Prop()
    show?: boolean;
}
